import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function PinkTickIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 15 15'} fontSize={'inherit'} {...props}>
      <path
        id="Tracé_73"
        data-name="Tracé 73"
        d="M5.732,12.061a1.021,1.021,0,0,1-.375-.071.743.743,0,0,1-.31-.233L.3,7.014A.938.938,0,0,1,0,6.3,1,1,0,0,1,.3,5.56a.942.942,0,0,1,.694-.277,1.03,1.03,0,0,1,.72.277l4.02,4.046L15.037.3a1,1,0,0,1,.717-.3.95.95,0,0,1,.711.3.982.982,0,0,1,.3.72.964.964,0,0,1-.3.714L6.443,11.757a.95.95,0,0,1-.336.233,1.021,1.021,0,0,1-.375.071"
        transform="translate(0 0)"
        fill="#d8006b"
      />
    </SvgIcon>
  );
}
